"use client";

import type {
  AdminService,
  AgentService,
  AuthService,
  BenchmarkService,
  ChatService,
  DashboardService,
  FileService,
  ProviderService,
  ProfileService,
  RitualService,
  SessionService,
  SkillService,
  WorkflowService
} from "@/services/contracts/services";
import { apiClient } from "@/services/api/client";

type StellaApi = {
  auth: AuthService;
  agents: AgentService;
  sessions: SessionService;
  chat: ChatService;
  rituals: RitualService;
  workflows: WorkflowService;
  profile: ProfileService;
  admin: AdminService;
  files: FileService;
  dashboard: DashboardService;
  benchmarks: BenchmarkService;
  providers: ProviderService;
  skills: SkillService;
};
export const api: StellaApi = apiClient;
